import { VBtn } from 'vuetify/lib/components/index.mjs';

export const buttonDefaults: Partial<VBtn> = {
  class: ['text-none'],
  variant: 'flat',
  slim: false,
  color: 'primary',
};
